import { doAppGraphqlRequest } from 'ducks/requests'

import { FETCH_COMPANIES } from '../types'
import {
  selectPageIsLoading,
  selectPageRequestKey,
  selectPageRequestVariables,
} from '../selectors'

import normalizationSchema from '../schema'

const query = `
  query Companies(
    $after: String,
    $filter: CompanyFilter,
    $first: Int,
  ) {
    companies(after: $after, filter: $filter, first: $first) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        id
        contacts {
          totalCount
        }
        createdAt
        customFieldValues {
          nodes {
            id
            key
            value {
              ... on File {
                url
              }
              ... on Text {
                content
              }
            }
          }
        }
      }
    }
  }
`

export function doFetchCompanies() {
  return (dispatch, getState) => {
    const state = getState()
    const loading = selectPageIsLoading(state)
    const requestKey = selectPageRequestKey(state)
    const variables = selectPageRequestVariables(state)

    if (loading) return null

    return dispatch(
      doAppGraphqlRequest(FETCH_COMPANIES, query, variables, {
        normalizationSchema,
        meta: {
          requestKey,
        },
      })
    )
  }
}
